import styled from '@emotion/styled'

export const VideoContainer = styled.div({
    position: 'absolute',
    borderRadius: 'inherit',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    pointerEvents: 'none',
    cursor: 'pointer',
    backgroundColor: 'transparent',
})
